import { Link } from '@mui/material';

interface ResetButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

const ResetButton = ({ onClick, disabled = false }: ResetButtonProps) => {
    return (
        <Link
            component="button"
            variant="body2"
            value="reset-view"
            underline="none"
            fontSize={12}
            onClick={() => {
                if (!disabled) {
                    onClick();
                }
            }}
            sx={{
                lineHeight: 1,
                padding: 0,
                color: disabled ? 'grey.500' : 'primary.main',
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? 'default' : 'pointer',
            }}
        >
            RESET
        </Link>
    );
};

export default ResetButton;
